import { atom } from 'jotai'

/**
 * 右側のコンテンツにレンダリングするためのDOM要素の指定用
 */
export const rightContentPortalElementAtom = atom<HTMLDivElement | null>(null)

rightContentPortalElementAtom.debugLabel = 'rightContentPortalElementAtom'
